import { useState } from 'react'
import { Carousel, CarouselItem, CarouselControl, CarouselIndicators, CarouselCaption } from 'reactstrap'

const items = [
  {
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/v1742798408/VantageFit/2025/Buyersguideimage-05/Buyers_guide_image-02.png',
    altText: 'The Ultimate Buyers Guide to Corporate Wellness Programs',
    caption: 'The Ultimate Buyers Guide to Corporate Wellness Programs',
    imagealtText: 'The Ultimate Buyers Guide to Corporate Wellness Programs Slide 1',
  },
  {
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/v1742798408/VantageFit/2025/Buyersguideimage-05/Buyers_guide_image-03.png',
    altText: 'The Ultimate Buyers Guide to Corporate Wellness Programs',
    caption: 'The Ultimate Buyers Guide to Corporate Wellness Programs',
    imagealtText: 'The Ultimate Buyers Guide to Corporate Wellness Programs Slide 2',
  },
  {
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/v1742798408/VantageFit/2025/Buyersguideimage-05/Buyers_guide_image-04.png',
    altText: 'The Ultimate Buyers Guide to Corporate Wellness Programs',
    caption: 'The Ultimate Buyers Guide to Corporate Wellness Programs',
    imagealtText: 'The Ultimate Buyers Guide to Corporate Wellness Programs Slide 3',
  },
]

const UltimateBuyersGuideCarousal = (props) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [animating, setAnimating] = useState(false)

  const next = () => {
    if (animating) return
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1
    setActiveIndex(nextIndex)
  }

  const previous = () => {
    if (animating) return
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1
    setActiveIndex(nextIndex)
  }

  const goToIndex = (newIndex) => {
    if (animating) return
    setActiveIndex(newIndex)
  }

  const slides = items.map((item) => {
    return (
      <CarouselItem onExiting={() => setAnimating(true)} onExited={() => setAnimating(false)} key={item.src}>
        <div className="row ">
          <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 pclr text-center">
            <img src={item.src} alt={item.imagealtText} className="img_shadow max-w" width="530" height="387" />
          </div>{' '}
        </div>
      </CarouselItem>
    )
  })

  return (
    <Carousel activeIndex={activeIndex} next={next} previous={previous}>
      <CarouselIndicators
        items={items}
        activeIndex={activeIndex}
        onClickHandler={goToIndex}
        className="commonindicator"
      />
      {slides}
      <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
      <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
    </Carousel>
  )
}

export default UltimateBuyersGuideCarousal
